import { render, staticRenderFns } from "./RestorePassForm.vue?vue&type=template&id=b84e13a8&scoped=true"
import script from "./RestorePassForm.vue?vue&type=script&lang=js"
export * from "./RestorePassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84e13a8",
  null
  
)

export default component.exports